import { createIcon } from './createIcon';

/** Magnifier — the leading affordance in a filter/search field. */
export const SearchIcon = createIcon({
  name: 'SearchIcon',
  viewBox: '0 0 16 16',
  size: 16,
  color: 'var(--text-secondary)',
  children: (
    <>
      <circle cx="7" cy="7" r="5" stroke="currentColor" strokeWidth="1.4" />
      <path
        d="M11 11l3 3"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
      />
    </>
  ),
});

export default SearchIcon;
